// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment_root__5Q1p-","icon":"Comment_icon__HYI-v","commentWrapper":"Comment_commentWrapper__IvihY","commentField":"Comment_commentField__37Km0"};